require('../../search/_track-report-submit');

$(() => {
  $('.panel-report.current button.btn-edit').click(function (e) {
    loadEditItem('report', $(this));
    e.preventDefault();
  });
  $('.panel-report.current button.btn-delete').click(function (e) {
    removeItem('report', $(this));
    e.preventDefault();
  });


  $('.panel-report.pending button.btn-edit').click(function (e) {
    loadEditItem('recording', $(this));
    e.preventDefault();
  });
  $('.panel-report.pending button.btn-delete').click(function (e) {
    removeItem('recording', $(this));
    e.preventDefault();
  });

  $('#updateRecordingBtn').click(updateItem);
});

function loadEditItem(type, btn) {
  const url = type === 'report' ? loadEditReportUrl : loadEditRecordingSubmissionUrl;
  const id = btn.data('id');

  btn.button('loading');

  $.post(url, {
    id
  }, (data, b) => {
    btn.button('reset');

    if (data.isError == 1) {
      toastr.error(data.msgError, 'Error');
    } else {
      $('#updateRecordingBtn').data('id', id);
      $('#updateRecordingBtn').data('type', type);
      $('#editRecordingSubmission .modal-body').html(data.html);
      $('#editRecordingSubmission').modal('show');
    }
  });
}

function removeItem(type, btn) {
  const url = type === 'report' ? deleteReportUrl : deleteRecordingSubmissionUrl;
  const id = btn.data('id');

  bootbox.confirm({
    title: __('Remove report'),
    message: __('Are you sure this report should be removed?'),
    buttons: {
      cancel: {
        label: `<i class="fa fa-times"></i> ${__('No')}`,
        className: 'btn-default btn-dark'
      },
      confirm: {
        label: `<i class="fa fa-check"></i> ${__('Yes')}`,
        className: 'btn-primary btn btn-space'
      }
    },
    callback(result) {
      if (result) {
        btn.button('loading');

        $.post(url, {
          id
        }, (data, b) => {
          btn.button('reset');

          if (data.isError == 1) {
            toastr.error(data.msgError, 'Error');
          } else {
            toastr.success(__('Report has been removed.'), __('Success'));
            location.reload();
          }
        });
      }
    }
  });
}

function updateItem(e) {
  const btn = $(this);
  const type = btn.data('type');
  $('#updateRecordingBtn .modal-footer button').hide();
  $('#updateRecordingBtn .modal-footer img').show();

  $('.help-block').remove();
  $('#updateRecordingBtn .form-group').removeClass('has-error');

  const url = type === 'report' ? editReportUrl : editRecordingSubmissionUrl;
  const id = btn.data('id');
  const updateForm = $('#editRecordingSubmission form');
  const dataArr = updateForm.serializeArray();

  $.post(url, {
    id,
    dataArr
  }, (data, b) => {
    $('#updateRecordingBtn .modal-footer button').show();
    $('#updateRecordingBtn .modal-footer img').hide();

    if (data.isError == 1) {
      toastr.error(data.msgError, 'Error');

      if (data.formErrorMessagess && data.formErrorMessagess.length !== 0) {
        $.each(data.formErrorMessagess, (elementId, value) => {
          $.each(value, (index, value) => {
            updateForm.find(`[name="${elementId}"]`).parent().addClass('has-error');
            updateForm.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
          });
        });
      }
    } else {
      $('#updateRecordingBtn').modal('hide');
      toastr.success(__('Report has been updated.'), __('Success'));
      location.reload();
    }
  }, 'json');
  e.preventDefault();
}
